export default __webpack_public_path__ + "static/media/before-you-start.c667ffb3.svg";